const NAME = 'tags';

export default {
  NAME
};
